/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "mse-tools-masthead-and-footer/lib/css/page-base.css";
import "mse-tools-masthead-and-footer/lib/css/stand-alone-page.css";
import "mse-tool-components/global.css";
import "mse-tool-components/all.css";
import "./src/scss/index.scss";

import { mseGTM } from "mse-tools-masthead-and-footer/lib/mse-gtm";

if (typeof window !== "undefined") {
  mseGTM();
}
